<template>
    <div>
        <div class="editor-title-toolbar">
            <ReturnButton
                class="return-btn"
                @click="clickReturnBtn"
                v-show="showReturnBtn !== null && showReturnBtn !== false"
                :label="returnLabel"
            />

            <div>
                <h2
                    style="margin-top: 0"
                    tkey="3D店鋪分享"
                >
                    {{i18n.tkey("lang_3d_shop_share")}}
                </h2>
            </div>

            <div class="right-operation-btn" v-show="false">

            </div>
        </div>

        <Share3DUrl
            :companycode="shopCompany.companycode"
            :url="shopUrl"
            :type="1"
        />
    </div>
</template>

<script setup>

import {computed, inject, ref, toRef, onBeforeMount, getCurrentInstance} from "vue";
import Share3DUrl from "@/components/shopopee/share/share3DUrl.vue";
import {useUserinfo} from "@/stores/userinfo";
import ReturnButton from "@/components/shopopee/common/returnButton.vue";

const showReturnBtn = defineProps(["showReturnBtn"])
const emits = defineEmits(["clickReturnBtn"])

const { getShopCompanyObj } = inject('shopControlFunc', { getShopCompanyObj: () => { return {} } })
const { proxy } = getCurrentInstance()
const shopCompany = ref(null)
const userInfoRef = toRef(useUserinfo())
const i18n = inject("i18n")

const returnLabel = computed(() => {
    let text = i18n.tkey("lang_return")

    return text
})

const shopUrl = computed(() => {
    let link = ""

    const companyObj = shopCompany.value
    const record15Obj = companyObj.additionalrecord15

    link = `${proxy.$ThreeDShopopeePath}${record15Obj.updatedid}/index/${record15Obj.addinfo14}/${companyObj.wa}/${companyObj.siojournal}`

    return link
})

function clickReturnBtn(){
    emits("clickReturnBtn")
}

onBeforeMount(() => {
    shopCompany.value = getShopCompanyObj()

})

</script>

<style scoped>

.editor-title-toolbar {
    text-align: center;
    position: relative;
    margin-bottom: 32px;
}

.editor-title-toolbar .return-btn {
    position: absolute;
    left: 0;
    top: 5px;
}

.editor-title-toolbar .right-operation-btn {
    position: absolute;
    right: 0;
    top: 0;
}

</style>